import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ags-session-carte-achat',
  templateUrl: './session-carte-achat.component.html',
  styleUrls: ['./session-carte-achat.component.scss']
})
export class SessionCarteAchatComponent implements OnInit {
  public idSession;
  @Input('idSession')
  set _idSession(value: string) {
    if (value) {
      this.idSession = value;
    }
  }

  constructor() {}

  ngOnInit() {}
}
